import { formatInstantToPtBR } from '@/shared/lib';
import type { ReminderGeneralHistoryFilters, ReminderHistoryFilters } from './types';

const isValidRecipientId = (value: unknown): value is number =>
  typeof value === 'number' && Number.isInteger(value) && value > 0;

export const normalizeReminderHistoryFilters = (
  filters: ReminderHistoryFilters
): ReminderHistoryFilters => {
  const normalized: ReminderGeneralHistoryFilters = {};

  if (filters.createdAt) {
    normalized.createdAt = filters.createdAt;
  }

  if (typeof filters.createdBy === 'number') {
    normalized.createdBy = filters.createdBy;
  }

  if (filters.category) {
    normalized.category = filters.category;
  }

  if ('recipientId' in filters && isValidRecipientId(filters.recipientId)) {
    normalized.recipientId = filters.recipientId;
  }

  return normalized;
};

export const hasActiveReminderHistoryFilters = (filters: ReminderHistoryFilters) =>
  Boolean(
    filters.createdAt ||
    filters.createdBy ||
    filters.category ||
    ('recipientId' in filters && isValidRecipientId(filters.recipientId))
  );

export const mapReminderHistoryDate = (value: string | null | undefined) => {
  if (!value) {
    return '-';
  }

  const normalizedValue =
    value.includes(' ') && !value.includes('T') ? value.replace(' ', 'T') : value;

  return formatInstantToPtBR(normalizedValue);
};
